"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setPreviewFileDefault = exports.setPreviewFileCellActive = exports.setPreviewFile = void 0;
const actions = __importStar(require("../../../../modules/shared/store/action_constants"));
const setPreviewFile = (data) => {
    return (dispatch) => {
        dispatch({
            type: actions.SET_PREVIEW_FILE,
            payload: data,
        });
    };
};
exports.setPreviewFile = setPreviewFile;
const setPreviewFileCellActive = (list) => {
    return (dispatch) => {
        dispatch({
            type: actions.SET_PREVIEW_FILE_CELL_ACTIVE,
            payload: list,
        });
    };
};
exports.setPreviewFileCellActive = setPreviewFileCellActive;
const setPreviewFileDefault = () => {
    return (dispatch) => {
        dispatch({
            type: actions.SET_PREVIEW_DEFAULT_ACTIVE,
        });
    };
};
exports.setPreviewFileDefault = setPreviewFileDefault;
//# sourceMappingURL=preview_file.js.map